'use client';
import { mockProductCategory, mockProductStatus } from '@/mock/sample.json';
import tableStyle from '@/components/pages/dashboard/tableStyle.module.css';
import CookieFunction from '@/functions/cookieFunction';
import { routing } from '@/i18n/routing';
import {
  createContext,
  useEffect,
  useState,
  ReactNode,
  useContext,
  ReactElement,
  JSXElementConstructor,
  Dispatch,
  SetStateAction,
} from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { useRouterPath } from '@/functions/routerPath';
import { usePathname, useRouter } from 'next/navigation';
import config, {
  bankTransactionType,
  paymentMethodsList,
  transactionStatusTitles,
  transactionTypes,
  TRIGGERS,
} from '@/api/global';
import LayoutIcons from '@/icons/layoutIcons';
import {
  address,
  Car,
  categoryType,
  mouseEvent,
  onClickPay,
  payType,
  productCardType,
  ResponseType,
  ServiceSubCategory,
  SetState,
  setState,
  shop,
  state,
  statusType,
  userInfo,
  walletInfoType,
} from '@/commonTypes';
import Api from '@/api';
import MainIcons from '@/icons/main';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import { useServerMessage } from '@/functions/useServerMessage';
// import { setTime } from 'react-datepicker/dist/dist/date_utils.js';

// 1. تعریف تایپ برای پیام سرور
interface ServerMessage {
  text: string;
  title?: string;
  backgroundColor?: string;
  type?: string;
}
type toolbarMenuItem = {
  id?: string | number;
  title?: string;
  href?: string;
  parent: string;
} | null;
type ConfirmationType = {
  title: string;
  text: string;
  confirmText: string;
  rejectText: string;
  confirmFunction: () => void;
  rejectFunction: () => void;
};
// 2. تعریف تایپ برای نقشه لغو آپلود
type CancelUploadMap = Record<string, string | boolean>;

interface singleItemType {
  type: 'edit' | 'add' | 'view';
  name?: string;
  data: any;
}
interface priceInfoType {
  min?: number;
  max?: number;
}
// 3. تعریف اینترفیس برای Context
interface LayoutContextType {
  serverMessage?: ServerMessage;
  setServerMessage?: React.Dispatch<React.SetStateAction<ServerMessage>>;
  showError: (error: unknown) => void;
  showSuccess: (code?: string) => void;
  theme: string;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
  dir: string;
  setDir: React.Dispatch<React.SetStateAction<string>>;
  mode: string;
  setMode: React.Dispatch<React.SetStateAction<string>>;
  trigger: any; // یا تایپ دقیق‌تر اگر نیاز است
  setTrigger: React.Dispatch<React.SetStateAction<any>>;
  reRender: any;
  setRerender: React.Dispatch<React.SetStateAction<any>>;
  login: string | boolean | undefined;
  setLogin: React.Dispatch<React.SetStateAction<string | boolean | undefined>>;
  logoutFunction: () => void;
  isWaiting: boolean;
  setIswaiting: React.Dispatch<React.SetStateAction<boolean>>;
  cancelUploadMap: CancelUploadMap;
  cancelUploadFor: (modalKey: string, reason?: string) => void;
  resetCancelUploadFor: (modalKey: string) => void;
  closeModal: (callback: () => void, isDefault?: boolean, modalKey?: string) => void;
  editInfo: any;
  setEditInfo: React.Dispatch<React.SetStateAction<any>>;
  showOverflow: boolean;
  setShowOverflow: React.Dispatch<React.SetStateAction<boolean>>;
  formLevel: number;
  setFormLevel: React.Dispatch<React.SetStateAction<number>>;
  STATUS_LIST: any[];
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  tabletLimit: number;
  mobileLimit: number;
  hoveredProduct?: productCardType;
  setHoveredproduct?: setState<productCardType | undefined>;
  compareList: productCardType[];
  setCompareList: setState<productCardType[]>;
  basket: productCardType[] | undefined;
  setBasket: setState<productCardType[] | undefined>;
  totalCount?: number;
  setTotalCount?: setState<Number>;
  deleteFromBasket?: (x: productCardType) => void;
  changeBasketCount: (x: productCardType, y: string, e: React.MouseEvent<HTMLDivElement>) => void;
  isLogin?: boolean;
  toolbarMenuList?: toolbarMenuItem[];
  priceSymbol: string;
  singleItem?: singleItemType;
  setSingleItem: SetState<singleItemType | undefined>;
  switchLanguage: (x: string) => void;
  callBackFav: (
    x?: productCardType,
    state?: productCardType,
    setState?: setState<productCardType>,
    callbackFavorite?: (x: productCardType) => void,
  ) => void;
  checkIfLogin?: (func?: () => void, e?: React.MouseEvent<HTMLElement>) => void;
  priceInfo?: priceInfoType;
  setPriceInfo?: setState<priceInfoType | undefined>;
  orderSteps?: { id?: number; title?: string; className?: string }[];
  loadingBasket: boolean | string | number;
  setLoadingBasket: setState<boolean | string | number>;
  sendBasketToCart: (x?: string, userId?: string | number, carId?: string | number) => void;
  getCartList: () => void;
  ruleList?: {
    id?: number | string;
    title?: string;
    icon?: React.ReactElement;
    text?: string;
  }[];
  loadingDeleteCartItem?: string | null | number;
  userInfo?: userInfo;
  setUserInfo?: setState<userInfo | undefined>;
  getUserInfo?: () => void;
  confirmation?: any;
  setConfirmation: setState<any | undefined | null>;
  totalPrice?: string | number;
  activeCar?: Car;
  setActiveCar?: setState<Car | undefined>;
  searchedPlate?: Car;
  setSearchedPlate?: setState<Car | undefined>;
  paymentStatusList?: { id?: string | number; title?: string; color?: string; bg?: string }[];
  rowPaletColors: {
    accent?: string;
    bg?: string;
    valColor?: string;
  }[];
  paymentTypeList?: { id?: string | number; title?: string }[];
  paymentFunction?: onClickPay;
  activeCategories: categoryType[];
  setActiveCategories: setState<categoryType[]>;
  guarantees?: { id?: number; title?: string; icon: ReactNode; bg?: string }[];
  paymentInfo?: { type?: payType; item?: any; callBack?: any };
  setPaymenyInfo?: setState<{ type?: payType; item?: any; callBack?: any }>;
  walletInfo?: walletInfoType;
  payPrice?: any;
  loadingPayment?: { inq?: boolean; pay?: boolean };
  setDefaultFunction?: any;
  generateBasketObject: (item?: productCardType) => void;
  footerSubCategory: ServiceSubCategory[];
  callBackDeleteAddress: (item?: address) => void;
  callBackEditAddress: (type: 'edit' | 'add', item?: address) => void;
  removeSearch?: boolean;
  setRemoveSearch?: setState<boolean>;
  statusListOrder?: statusType[];
  productCategoryList?: categoryType[];
  productStatusList?: statusType[];
}

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};
// ایجاد Context با تایپ مشخص
export const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

// تایپ برای Props کامپوننت
interface LayoutProviderProps {
  children: ReactNode;
}
interface classItem {
  id: number;
  title: number;
  showList: string[];
  devices: string[];
  icon: ReactElement<any, string | JSXElementConstructor<any>>;
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  const pathname = usePathname();
  const locale = useLocale();
  const routerPath = useRouterPath();
  const t = useTranslations('common');

  const [isLogin, setIsLogin] = useState<boolean>();
  const [serverMessage, setServerMessage] = useState<ServerMessage>({ text: '', title: '' });
  const { translateCode, translateError } = useServerMessage();
  const [removeSearch, setRemoveSearch] = useState(false);

  const showError = (error: unknown) => {
    setServerMessage({ title: 'error', type: 'error', text: translateError(error) });
  };
  const showSuccess = (code?: string) => {
    setServerMessage({ title: 'success', type: 'success', text: translateCode(code, '') });
  };
  const [mode, setMode] = useState<string>('dark');
  const [theme, setTheme] = useState<string>('blue');
  const [dir, setDir] = useState<string>('ltr');
  const [trigger, setTrigger] = useState<any>(undefined);
  const [reRender, setRerender] = useState<any>(undefined);
  const [formLevel, setFormLevel] = useState<number>(1);
  const [showOverflow, setShowOverflow] = useState<boolean>(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [hoveredProduct, setHoveredproduct] = useState<productCardType | undefined>();
  const [compareList, setCompareList] = useState<productCardType[]>([]);
  const [footerSubCategory, setFooterSubCategory] = useState([]);
  const [basket, setBasket] = useState<productCardType[]>();
  const tCommon = useTranslations('common');
  const [totalCount, setTotalCount] = useState(
    basket?.reduce((sum, product) => sum + Number(product.count), 0),
  );
  const [totalPrice, setTotalPrice] = useState(0);
  const [loadingBasket, setLoadingBasket] = useState<boolean | string | number>(false);
  const [singleItem, setSingleItem] = useState<singleItemType>();
  const priceSymbol = 'ریال';
  const [priceInfo, setPriceInfo] = useState<priceInfoType | undefined>();
  // { min: 0, max: 0 }
  const router = useRouter();
  const [loadingDeleteCartItem, setLoadingDeleteCartItem] = useState<string | number | null>(null);
  const [userInfo, setUserInfo] = useState<userInfo | undefined>(
    //   {
    //   name: 'سارا احمدی',
    //   id: 2,
    //   mobile: '09121232344',
    // }
  );
  const [confirmation, setConfirmation] = useState<ConfirmationType | null>(null);

  const [activeCategories, setActiveCategories] = useState<categoryType[]>([]);
  const [walletInfo, setWalletInfo] = useState({ balance: 0 });
  const [productCategoryList, setProductCategoryList] = useState(mockProductCategory);
  const [productStatusList, setproductStatusList] = useState(mockProductStatus);

  const checkIfLogin = (func?: () => void, e?: React.MouseEvent<HTMLElement>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isLogin) {
      func?.();
    } else {
      setServerMessage({
        title: 'error',
        text: tCommon('userNotLogin'),
      });
    }
  };
  const getUserInfo = () => {
    Api.userInfo({})
      .then((res) => {
        const response = res?.data?.response;
        setUserInfo({ ...response, name: response?.display_name });
      })
      .catch((err) => {
        console.error('getUserInfo failed:', err);
      });
  };

  const deleteFromBasket = (item: productCardType) => {
    if (!isLogin) {
      setBasket(basket?.filter((x) => x.id != item?.id));
    } else {
      item?.id && setLoadingDeleteCartItem(item?.id);
      Api.deleteCartItem(item?.id)
        .then((res) => {
          reRenderCard();
        })
        .catch((err) => {
          showError(err);
        });
    }
  };
  console.log('userInfo========', userInfo);
  console.log('loadingDeleteCartItem====', loadingDeleteCartItem);
  const changeBasketCount = (
    item: productCardType,
    type: string,
    e: React.MouseEvent<HTMLDivElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (basket) {
      let newarray = [...basket];
      const index = basket?.findIndex((x) => x.id == item?.id);
      if (type == 'add') {
        if (!isLogin) {
          newarray[index].count = Number(newarray[index].count) + 1;
          setBasket(newarray);
        } else {
          if (item?.id !== undefined) {
            setLoadingBasket(item?.id);
          }
          Api.addEditCart({
            productId: item?.id,
            quantity: Number(item?.count) + 1,
          })
            .then((res) => {
              reRenderCard();
            })
            .catch((err) => {
              setLoadingBasket(false);
              showError(err);
            });
        }
      }
      if (type == 'remove') {
        if (newarray?.[index]?.count != 1) {
          if (!isLogin) {
            newarray[index].count = Number(newarray[index].count) - 1;
            setBasket(newarray);
          } else {
            if (item?.id !== undefined) {
              setLoadingBasket(item?.id);
            }
            Api.addEditCart({
              productId: item?.id,
              quantity: Number(item?.count) - 1,
            })
              .then((res) => {
                reRenderCard();
              })
              .catch((err) => {
                setLoadingBasket(false);
                showError(err);
              });
          }
        } else {
          deleteFromBasket(item);
        }
      }
    }
  };

  const reRenderCard = () => {
    setRerender(TRIGGERS.RERENDER_BASKETMODAL);
  };
  useEffect(() => {
    let isLogin = CookieFunction('get', config.tokenName);

    if (!isLogin) {
      if (basket) {
        CookieFunction('set', config.caraCart, JSON.stringify(basket), 30);
        setTotalCount(basket.reduce((sum, product) => sum + Number(product.count), 0));
        const total = basket.reduce(
          (sum, product) =>
            sum + Number(String(product.price).replace('$', '')) * (Number(product.count) || 1),
          0,
        );

        setTotalPrice(total);
        // } else {
        // CookieFunction('remove', config.caraCart);
        // setTotalCount(0);
        // setTotalPrice(0);
      }
    }
  }, [basket]);

  useEffect(() => {
    getCarServices();
  }, []);

  // const sendBasketToCart = (token?: string, userId?: string | number, carId?: string | number) => {
  //   if (!basket?.length) {
  //     return Promise.resolve();
  //   }

  //   return Promise.all(
  //     basket.map((item) =>
  //       Api.addEditCart(
  //         {
  //           productId: item.id,
  //           quantity: Number(item.count),
  //         },
  //         {
  //           Authorization: token ? `Bearer ${token}` : '',
  //           lang: locale,
  //           sub_user_id: userId,
  //           car_id: carId,
  //         },
  //       ),
  //     ),
  //   );
  // };
  // const sendBasketToCart = (token?: string) => {
  //   if (!basket?.length) {
  //     return Promise.resolve();
  //   }

  //   return Promise.all(
  //     basket.map((item) =>
  //       Api.addEditCart(
  //         {
  //           productId: item.id,
  //           quantity: Number(item.count),
  //         },
  //         {
  //           Authorization: token ? `Bearer ${token}` : '',
  //           lang: locale,
  //         },
  //       ),
  //     ),
  //   );
  // };
  const sendBasketToCart = (token?: string) => {
    if (basket?.length != 0 && basket) {
      return Promise.resolve();
    }
    let basketDummy = basket ? basket : [];
    return Promise.all(
      basketDummy?.map((item) =>
        Api.addEditCart(
          {
            productId: item.id,
            quantity: Number(item.count),
          },
          {
            Authorization: token ? `Bearer ${token}` : '',
            lang: locale,
          },
        ),
      ),
    );
  };
  const findOrderSummary = () => {
    Api
      .orderSummary
      // { params: params }
      ()
      .then((res) => {
        setTotalPrice(res?.data?.response?.subtotal);
      })
      .catch((err) => {
        console.error('findOrderSummary failed:', err);
      });
  };
  const getCartList = () => {
    let isLogin = CookieFunction('get', config.tokenName);
    if (!isLogin) {
      const cookie = CookieFunction('get', config.caraCart);
      if (cookie) {
        setBasket(JSON.parse(cookie));
      }
    } else {
      Api.cartList()
        .then((res) => {
          const response = res?.data?.response?.map(
            (x: { quantity: string | number; productId?: number | string }) => {
              return { ...x, count: x?.quantity, id: x?.productId };
            },
          );
          setRerender(TRIGGERS.EMPTY);
          setBasket(response);
          // setTotalCount(res?.data?.response_details?.count);
          setTotalCount(
            response?.reduce(
              (sum: any, product: { count?: string | number }) => sum + Number(product.count),
              0,
            ),
          );
          findOrderSummary();

          setLoadingBasket(false);
          setLoadingDeleteCartItem(null);
        })
        .catch((err) => {
          setLoadingBasket(false);
          setLoadingDeleteCartItem(null);
        });
    }
  };

  useEffect(() => {
    getCartList();
  }, []);
  useEffect(() => {
    if (trigger == TRIGGERS.BASKETMODAL) {
      getCartList();
    }
  }, [trigger]);

  useEffect(() => {
    if (reRender == TRIGGERS.RERENDER_BASKETMODAL) {
      getCartList();
    }
  }, [reRender]);

  const switchLanguage = (newLocale: string) => {
    console.log('newLocale==', newLocale);
    const segments = pathname.split('/').filter(Boolean);
    // CookieFunction('set', config.languageDidarin, newLocale, 365);

    if (routing.locales.includes(segments[0])) {
      segments.shift();
    }

    if (newLocale !== routing.defaultLocale) {
      segments.unshift(newLocale);
    }

    const newPath = '/' + segments.join('/');
    // router.push(newPath);
    window.location.href = newPath;
  };

  const toolbarMenuList = [
    {
      id: 'services',
      title: t('services'),
      href: '/allServices',
      parent: '/allServices',
    },
    {
      id: 'brand',
      title: t('brand'),
      href: '/brands',
      parent: '/brands',
    },
    {
      id: 'blog',
      title: t('blog'),
      href: '/blogs',
      parent: '/blogs',
    },
    {
      id: 'about',
      title: t('about'),
      href: '/about',
      parent: '/about',
    },
    {
      id: 'contact',
      title: t('contactus'),
      href: '/contactUs',
      parent: '/contactUs',
    },
    Number(process.env.version) > 1
      ? {
          id: 'products',
          title: t('products'),
          href: '/products',
          parent: '/products',
        }
      : null,
    Number(process.env.version) > 1
      ? {
          id: 'services',
          title: t('shopServices'),
          href: '/shop-services',
          parent: '/shop-services',
        }
      : null,
  ];

  const rowPaletColors = [
    {
      accent: '#E0492B',
      bg: '#FDECE7',
      valColor: '#E0492B',
    },
    {
      accent: '#3B82F6',
      bg: '#EAF2FF',
      valColor: '#3B82F6',
    },
    {
      accent: '#22C55E',
      bg: '#ECFDF3',
      valColor: '#22C55E',
    },
    {
      accent: '#A855F7',
      bg: '#F5F3FF',
      valColor: '#A855F7',
    },
  ];
  const paymentTypeList = [
    { id: 1, title: 'کیف پول' },
    { id: 2, title: 'آنلاین' },
  ];

  const STATUS_LIST: any[] = [];

  const [login, setLogin] = useState<string | boolean | undefined>(
    typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      CookieFunction('get', config.tokenName),
  );
  const [isWaiting, setIswaiting] = useState<boolean>(false);
  const [editInfo, setEditInfo] = useState<any>(undefined);

  const [cancelUploadMap, setCancelUploadMap] = useState<CancelUploadMap>({});

  const cancelUploadFor = (modalKey: string, reason: string = 'closeModal') => {
    setCancelUploadMap((prev) => ({ ...prev, [modalKey]: reason }));
  };

  const resetCancelUploadFor = (modalKey: string) => {
    setCancelUploadMap((prev) => ({ ...prev, [modalKey]: false }));
  };

  const closeModal = (callback: () => void, isDefault: boolean = true, modalKey: string = '') => {
    if (!isDefault && modalKey) {
      cancelUploadFor(modalKey, 'closeModal');
    } else {
      callback();
    }
  };

  const logoutFunction = () => {
    CookieFunction('remove', config.tokenName);
    CookieFunction('remove', config.levelManageName);
    CookieFunction('remove', config.userIdCara);
    CookieFunction('remove', config.carIdCara);
    CookieFunction('remove', config.superUserIdCara);

    const path = routerPath('/');
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      window.location.href = path;
    }
  };

  // Effects
  useEffect(() => {
    const modeValue = CookieFunction('get', config.modeName) || 'dark';
    const themeValue = CookieFunction('get', config.themeName) || 'blue';
    setMode(modeValue);
    setTheme(themeValue);
    setDir(config.isRTL(locale) ? 'rtl' : 'ltr');
  }, [locale]); // اضافه کردن locale به وابستگی‌ها برای جلوگیری از هشدار

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.setAttribute('data-mode', mode);
  }, [theme, mode]);

  useEffect(() => {
    if (serverMessage?.text?.trim()?.length !== 0) {
      const timer = setTimeout(
        () => {
          setServerMessage({ text: '' });
        },
        serverMessage?.type === 'error' ? 6000 : 3000,
      );
      return () => clearTimeout(timer); // پاکسازی تایمر
    }
  }, [serverMessage]);

  useEffect(() => {
    setVisible(true);
  }, [pathname]);

  useEffect(() => {
    if (typeof window != undefined && typeof document != undefined) {
      let isLoggged = CookieFunction('get', config.tokenName) ? true : false;
      setIsLogin(isLoggged);
      if (isLoggged) {
        getUserInfo();
        getDefault();
        getWalletInfo();
      }
    }

    getPriceInfo();
  }, [pathname]);

  const getWalletInfo = () => {
    Api.getWallet()
      .then((res) => {
        setWalletInfo(res?.data?.response);
      })
      .catch((err) => {
        console.error('getWalletInfo failed:', err);
      });
  };

  console.log('walletInfo====', walletInfo);
  const tabletLimit = 1024;
  const orientationLimit = 760;
  const mobileLimit = 360;

  // ============================  cara

  let sample = {
    plate: TransformPlateNumber('ایران ۸۸ - ۴۱۴ ج ۸۷'),
    name: 'پریا رحیمی',
    id: 1,
    mobile: '0912 345 6789',
  };
  const [activeCar, setActiveCar] = useState<Car>();
  const [searchedPlate, setSearchedPlate] = useState<Car | undefined>();

  const [paymentStatusList, setPaymentStatusList] = useState([
    {
      id: transactionStatusTitles?.TransactionStatusSuccess,
      title: 'موفق',
      color: 'var(--green)',
      bg: 'var(--green-bg)',
    },
    {
      id: transactionStatusTitles?.TransactionStatusFailed,
      title: 'ناموفق',
      color: 'var(--danger)',
      bg: 'var(--danger-bg)',
    },
    {
      id: transactionStatusTitles?.TransactionStatusPending,
      title: 'درحال انجام',
      color: 'var(--brand)',
      bg: 'var(--tag-bg)',
    },
    {
      id: transactionStatusTitles?.TransactionStatusVerified,
      title: 'تایید شده',
      color: 'var(--accent)',
      bg: 'var(--accent-b)',
    },
  ]);
  const orderSteps = [
    { id: 1, title: tCommon('pending'), className: tableStyle.statusPending },
    { id: 2, title: tCommon('paid'), className: tableStyle.statusPaid },
    { id: 3, title: tCommon('shipped'), className: tableStyle.statusSent },
    { id: 4, title: tCommon('delivered'), className: tableStyle.statusDelivered },
    { id: 5, title: tCommon('cancelled'), className: tableStyle.statusCanceled },
  ];
  const [paymentInfo, setPaymentInfo] = useState<{
    type?: payType;
    item?: any;
    callBack?: any;
    allPlates?: boolean;
  } | null>(null);

  const [loadingPayment, setLoadingPayment] = useState({ inq: false, pay: false });

  const paymentFunction = (
    type: payType = 'inq',
    item?: any,
    callBack?: any,
    allPlates?: boolean,
  ) => {
    // const car_id = CookieFunction('get', config.carIdCara);
    // if (item?.show_plate) {
    //   if (!car_id) {
    //     setServerMessage({ title: 'error', text: 'پلاک دیفالت را مشخص کنید.' });
    //     return;
    //   }
    // }
    setTrigger(TRIGGERS.PAYMENT_MODAL);
    setPaymentInfo({
      type: type,
      item: item,
      callBack: (x: any) => {
        getWalletInfo();
        callBack?.(x);
      },
      allPlates: allPlates,
    });
  };

  const callBackFav = (
    item?: productCardType,
    state?: productCardType,
    setState?: setState<productCardType>,
    callbackFavorite?: (x: productCardType) => void,
  ) => {
    if (state && state?.isLiked) {
      callBackFavConfirm(item, state, setState, callbackFavorite);
    } else {
      Api.addWishlist({ productid: item?.id })
        .then((res) => {
          setState && setState({ ...state, isLiked: !state?.isLiked });
          // setUserInfo({ ...userInfo, wishlist: Number(userInfo?.wishlist) + 1 });
          getUserInfo();
          callbackFavorite && callbackFavorite({ ...state, isLiked: !state?.isLiked });
          setServerMessage({
            title: 'title',
            text: t('favSuccess'),
            type: 'success',
          });
        })
        .catch((err) => {
          showError(err);
        });
    }
  };
  const callBackUnFav = (
    item?: productCardType,
    state?: productCardType,
    setState?: setState<productCardType>,
    callbackFavorite?: (x: productCardType) => void,
  ) => {
    Api.removeWishlist(item?.id)
      .then((res) => {
        setState && setState({ ...state, isLiked: !state?.isLiked });
        // setUserInfo({ ...userInfo, wishlist: Number(userInfo?.wishlist) - 1 });
        getUserInfo();
        callbackFavorite && callbackFavorite({ ...state, isLiked: !state?.isLiked });
        setServerMessage({
          title: 'title',
          text: t('unfavSuccess'),
          type: 'success',
        });
      })
      .catch((err) => {
        showError(err);
      });
  };
  const callBackFavConfirm = (
    item?: productCardType,
    state?: productCardType,
    setState?: setState<productCardType>,
    callbackFavorite?: (x: productCardType) => void,
  ) => {
    setConfirmation({
      title: t('unFavProduct'),
      text: t('areyousure'),
      confirmText: t('yes'),
      rejectText: t('no'),
      confirmFunction: () => callBackUnFav(item, state, setState, callbackFavorite),
      rejectFunction: () => {
        setConfirmation(null);
      },
    });
  };
  const getPriceInfo = () => {
    Api.priceRange()
      .then((res) => {
        setPriceInfo(res?.data?.response);
      })
      .catch((err) => {
        console.error('getPriceInfo failed:', err);
      });
  };

  const guarantees = [
    {
      id: 1,
      title: 'ضمانت اصالت و سلامت فیزیکی',
      icon: <MainIcons.shieldIcon fill="var(--brand-deep)" width="17px" height="17px" />,
      bg: 'var(--tag-bg)',
    },
    {
      id: 2,
      title: '۷ روز ضمانت بازگشت کالا',
      icon: <MainIcons.returnIcon fill="var(--brand-deep)" width="17px" height="17px" />,
      bg: 'var(--purple-bg)',
    },
    {
      id: 3,
      title: 'پرداخت امن از طریق کیف پول کارا',
      icon: <MainIcons.CheckedIcon fill="var(--brand-deep)" width="17px" height="17px" />,
      bg: 'var(--green-bg)',
    },
  ];

  const paymentApi = (x?: any) => {
    console.log('x=====', x);
    const car_id = CookieFunction('get', config.carIdCara);
    const sub_user_id = CookieFunction('get', config.userIdCara);

    let apiCall = null;
    let params = {};
    if (x?.type == 'inq') {
      if (!x?.allPlates) {
        params = {
          payment_method: x?.payment_method,
          service_identifier: x?.item?.key,
          violation_id: x?.item?.violation_id ? x?.item?.violation_id : undefined,
        };
        apiCall = Api.serviceInquery({ params: params });
      } else {
        console.log('all-violations');
        if (x?.payment_method == paymentMethodsList?.wallet) {
          apiCall = Api.allPlatesInq();
        } else {
          params = {
            sub_type: transactionTypes.TransactionSubTypeAllViolation,

            type: bankTransactionType.withdraw,
            // amount: Number(x?.item?.price),
          };
          apiCall = Api.payment(params);
        }
      }
      setLoadingPayment({ inq: true, pay: false });
    } else {
      params = {
        // payment_method: x?.payment_method,
        // amount: Number(x?.item?.price),
        violation_id: x?.item?.response?.violation_id ? x?.item?.response?.violation_id : undefined,
        bill_id: x?.item?.response?.paper_id,
        car_id: Number(car_id),
        pay_id: x?.item?.response?.payment_id,
        source_id: Number(x?.item?.service_id),
        sub_type: x?.allPlates
          ? transactionTypes.TransactionSubTypeAllViolation
          : transactionTypes.TransactionSubTypeDept,
        sub_user_id: Number(sub_user_id),
        type: bankTransactionType.withdraw,
        history_id: x?.item?.history_id,
      };
      apiCall = Api.payment(params);
      setLoadingPayment({ inq: false, pay: true });
    }
    console.log('params======', x);

    apiCall &&
      apiCall
        .then((res) => {
          console.log('res==', res?.data?.response);

          setPaymentInfo(null);
          if (x?.payment_method == paymentMethodsList?.bank) {
            if (res?.data?.url) {
              window.location.href = res?.data?.url;
            }
          } else {
            getWalletInfo();
            x?.callBack(res?.data?.response);
          }
          setLoadingPayment({ inq: false, pay: false });
          setTrigger(TRIGGERS.EMPTY);
        })
        .catch((err) => {
          setLoadingPayment({ inq: false, pay: false });
          showError(err);
        });
  };
  const payPrice = (x?: any) => {
    checkIfLogin &&
      checkIfLogin(() => {
        if (!x?.allPlates) {
          const rawCarId = CookieFunction('get', config.carIdCara);
          const rawSubUserId = CookieFunction('get', config.userIdCara);

          const car_id =
            rawCarId === 'null' || rawCarId === 'undefined' || rawCarId === '' ? null : rawCarId;

          const sub_user_id =
            rawSubUserId === 'null' || rawSubUserId === 'undefined' || rawSubUserId === ''
              ? null
              : rawSubUserId;

          console.log('car_id==', car_id);

          if (
            // x?.item?.show_plate &&
            !car_id &&
            !sub_user_id
          ) {
            setServerMessage({ title: 'error', text: t('selectDefaultCarAndUser') });
            return;
          }
          if (
            !x?.item?.show_plate &&
            // !car_id &&
            !sub_user_id
          ) {
            setServerMessage({ title: 'error', text: t('selectDefaultUser') });
            return;
          }
        }
        paymentApi(x);
      });
  };
  const getDefault = () => {
    Api.getDefault()
      .then((res) => {
        console.log('resis========', res);
        let response = res?.data?.response;
        setActiveCar({
          plate: TransformPlateNumber(response?.plate?.license_plate),
          name: response?.sub_user?.display_name,
          id: response?.plate?.id,
          mobile: response?.mobile,
        });
        CookieFunction('set', config.carIdCara, response?.car_id, 365);
        CookieFunction('set', config.userIdCara, response?.sub_user_id, 365);
      })
      .catch((err) => {
        console.error('getDefault failed:', err);
      });
  };
  const setDefaultFunction = (c?: Car, path?: string) => {
    Api.setDefault({
      car_id: c?.id,
      sub_user_id: c?.user?.id,
    })
      .then((res) => {
        CookieFunction('remove', config.carIdCara);
        CookieFunction('remove', config.userIdCara);
        setTimeout(() => {
          const response = res?.data?.response;
          CookieFunction('set', config.carIdCara, c?.id, 365);
          CookieFunction('set', config.userIdCara, c?.user?.id, 365);
          // getDefault();
          // window.location?.reload();
          if (path) {
            window.location.href = path;
          } else {
            window.location?.reload();
          }
        }, 1000);
      })
      .catch((err) => {
        showError(err);
      });
  };
  const generateBasketObject = (item: productCardType) => ({
    id: item?.id,
    title: item?.title,
    shop: item?.shop,
    price: item?.price,
    discount: item?.discount,
    slug: item?.slug,
    distance: item?.distance,
  });

  const getCarServices = () => {
    Api.serviceSubCategoryList({ params: { category_id: 1, start: 0, limit: 4 } })
      .then((res) => {
        setFooterSubCategory(res?.data?.response);
      })
      .catch((err) => {
        console.error('footer subcategories fetch failed:', err);
      });
  };

  const callBackDeleteAddressConfirm = (item?: address) => {
    Api.deleteAddress(item?.id)
      .then((res) => {
        setTrigger(TRIGGERS.RERENDER);
        setUserInfo({
          ...userInfo,
          // addresses: Number(userInfo?.addresses) - 1
        });
      })
      .catch((err) => {});
  };
  const callBackDeleteAddress = (item?: address) => {
    setConfirmation({
      title: t('deleteAddress'),
      text: t('areyousure'),
      confirmText: t('yes'),
      rejectText: t('no'),
      confirmFunction: () => callBackDeleteAddressConfirm(item),
      rejectFunction: () => {
        setConfirmation(null);
      },
    });
  };
  const callBackEditAddress = (type: 'edit' | 'add', item?: address) => {
    setSingleItem({ name: 'address', type: type, data: item });

    setTrigger(TRIGGERS.FORM_MODAL);
  };
  const statusListOrder = [];
  console.log('basket==', basket);
  return (
    <LayoutContext.Provider
      value={{
        serverMessage,
        setServerMessage,
        showError,
        showSuccess,
        theme,
        setTheme,
        dir,
        setDir,
        mode,
        setMode,
        trigger,
        setTrigger,
        reRender,
        setRerender,
        login,
        setLogin,
        logoutFunction,
        isWaiting,
        setIswaiting,
        cancelUploadMap,
        cancelUploadFor,
        resetCancelUploadFor,
        closeModal,
        editInfo,
        setEditInfo,
        showOverflow,
        setShowOverflow,
        formLevel,
        setFormLevel,
        STATUS_LIST,
        visible,
        setVisible,

        tabletLimit,
        mobileLimit,

        hoveredProduct,
        setHoveredproduct,

        compareList,
        setCompareList,
        basket,
        setBasket,
        totalCount,
        deleteFromBasket,
        changeBasketCount,
        isLogin,
        toolbarMenuList,
        priceSymbol,
        singleItem,
        setSingleItem,
        switchLanguage,

        checkIfLogin,
        loadingBasket,
        setLoadingBasket,

        priceInfo,
        setPriceInfo,

        sendBasketToCart,
        getCartList,

        userInfo,
        setUserInfo,
        confirmation,
        setConfirmation,
        totalPrice,

        activeCar,
        setActiveCar,

        searchedPlate,
        setSearchedPlate,
        paymentStatusList,
        rowPaletColors,
        paymentTypeList,
        paymentFunction,
        callBackFav,
        activeCategories,
        setActiveCategories,
        guarantees,

        paymentInfo,
        setPaymentInfo,
        walletInfo,
        setWalletInfo,
        payPrice,
        loadingPayment,
        setDefaultFunction,
        getUserInfo,
        getWalletInfo,
        generateBasketObject,
        footerSubCategory,
        callBackDeleteAddress,
        callBackEditAddress,
        removeSearch,
        setRemoveSearch,
        statusListOrder,
        orderSteps,
        productCategoryList,
        productStatusList,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
